module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M24 9h-2V4h-7V2h9v7zm-9 13v-2h7v-5h2v7h-9zM0 15h2v5h7v2H0v-7zM9 2v2H2v5H0V2h9z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/fullscreen.svg
// module id = pzVx
// module chunks = 89